import { render } from "./back-button.vue?vue&type=template&id=9edd332a&scoped=true"
const script = {}

import "./back-button.vue?vue&type=style&index=0&id=9edd332a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9edd332a"]])

export default __exports__